"use strict";
var uncurryThis = require("../internals/function-uncurry-this");
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var $ArrayCopyWithin = require("../internals/array-copy-within");
var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod("copyWithin", function copyWithin(target, start) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : void 0);
});
